// extracted by mini-css-extract-plugin
export var askAiIcon = "_q3-9";
export var container = "_q3-0";
export var groupSeparator = "_q3-a";
export var highlight = "_q3-4";
export var resultIcon = "_q3-5";
export var resultItem = "_q3-7";
export var resultSubtitle = "_q3-3";
export var resultTitle = "_q3-2";
export var resultsList = "_q3-1";
export var searchGroup = "_q3-6";
export var selected = "_q3-8";